import React, { Fragment } from 'react'
import { css } from '@linaria/core'
import { Paragraph, Button, useContainerWidth, Separator, Row, Image } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import InfoCard from '../info-card/PersonInfoCard'

import svg from './CreateAccount.svg'

const cardBodyCss = css`
  display: flex;
  flex-direction: column;
`

export default function CreateAccountCard({ baseUrl, ...props }) {
  const atContainerWidth = useContainerWidth()
  const [t] = useTranslation()
  const isMobile = atContainerWidth({ default: true, lg: false })
  const linkUrl = baseUrl || ''

  const buttonText = isMobile ? t('info-cards.create-account.action') : t('info-cards.create-free-account.action')

  const Wrapper = isMobile ? Fragment : Row
  return (
    <InfoCard transparent heading={t('info-cards.create-account.header')} {...props}>
      <div className={cardBodyCss} style={{ alignItems: isMobile ? 'center' : 'initial' }}>
        <Wrapper>
          <Paragraph size="sm">{t('info-cards.create-account.description')}</Paragraph>
          {isMobile && <Separator size="xxs" />}
          <Image
            noShrinkX
            maxWidth={112}
            src={svg}
            alt={t('info-cards.create-account-img.alt')}
            data-testid="create-account-img"
          />
        </Wrapper>
        <Separator size="xxs" />
        <Button
          emphasis="high"
          data-testid="create-account"
          to={`${linkUrl}/identity/signup/`}
          linkName="Create Account: Create A Free Account"
          external
        >
          {buttonText}
        </Button>
      </div>
    </InfoCard>
  )
}
